/*global autocomplete, menu, myBooking, authentication, searchbox, terms, sfr, notifications, sp, freeExtras,
    locationModal, bp, pp, slider, lMap, cbp, creditCard, payment, modification, cancellation, compensation, review, utilities,
    myModal, myCookie, tooltip, myDataLayer, googleConversionId, googleConversionLabel, googleTagParams, googleRemarketingOnly,
    notification, thumbRating, reviewUpload, toggle, tabs, pickDL, account, analyticEventTracker, chatBot, referral */

'use strict';

$(function() {
    jQuery.event.special.touchstart = {
        setup: function( _, ns, handle ) {
            this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
        }
    };
    jQuery.event.special.touchmove = {
        setup: function( _, ns, handle ) {
            this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
        }
    };
    jQuery.event.special.wheel = {
        setup: function( _, ns, handle ) {
            this.addEventListener('wheel', handle, { passive: false, capture: true });
        }
    };
    jQuery.event.special.mousewheel = {
        setup: function( _, ns, handle ) {
            this.addEventListener('mousewheel', handle, { passive: false, capture: true });
        }
    };

    $( document ).ajaxError(function(event, jqxhr) {
        if (jqxhr.status === 418) {
            if (jqxhr.responseJSON !== undefined && jqxhr.responseJSON.redirectTo !== undefined) {
                document.location = jqxhr.responseJSON.redirectTo;
            } else {
                document.location = _d.recaptcha;
            }
        }
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // jQuery.ajax({
    //     url: '/portal/click',
    //     data: _d.dchToken,
    //     success: function() {
    //         return true;
    //     },
    //     async: true
    // });


    $('body').on('click', '.disabled, [disabled]', function(e) {
        e.preventDefault();
    }).on('click', '.submit', function() {
        var that = $(this);

        if (!that.hasClass('prevent-loading')) {
            that.addClass('loading');
        } else {
            that.blur();
        }
    }).on('input blur paste', '.js-multiple-to-single', function() {
        const that = $(this);
        const value = (that.val()).replace(/\s\s+/g, ' ').replace(/\.\.+/g, '.').replace(/\-\-+/g, '-'); // multiple spaces, dots or hyphens to single space, dot or hyphen
        that.val(value);
    }).on('click', '.js-aria-expanded', function() {
        const that = $(this);
        if (that.hasClass('opened')) {
            that.attr('aria-expanded', false);
        } else {
            that.attr('aria-expanded', true);
        }
    });

    let mapXYName = '';
    let mapXY = [103, 116, 109, 95, 103, 97, 95, 103, 103, 98, 105, 116];
    for (let i in mapXY) {
        if (Object.prototype.hasOwnProperty.call(mapXY, i)) {
            mapXYName += String.fromCharCode(mapXY[i]);
        }
    }


    $('.validate-input').on('keyup', function() {
        var handler = $(this);

        if (handler.val().length > 0) {
            handler.parent().removeClass('error');
        }
    });

    $('.select-box select').on('focus', function() {
        $(this).parent().addClass('active');
    }).on('blur', function() {
        $(this).parent().removeClass('active');
    });

    $('html').on('click', function(e) {
        $('.navigation-block, .navigation-link, .header').removeClass('active');
        $('.extra-select-dropdown').addClass('closed');
        if (!$(e.target).hasClass('sb-driver-age-text') && $('.age-dropdown').find(e.target).length === 0) {
            $('.age-dropdown').addClass('closed');
        }
        if (!$(e.target).hasClass('sb-residence-text') && $('.residence-dropdown').find(e.target).length === 0) {
            $('.residence-dropdown').addClass('closed');
        }

        $('.residence-select').trigger('chosen:close');
    });

    $('.more-details').on('click', function(e) {
        e.preventDefault();
        var that = $(this),
            el = that.data('block');

        that.hide();
        $('#' + el).show();
    });

    var svgConvertor = [
        [109, 97, 105, 110, 45, 119, 114, 97, 112, 112, 101, 114, 45, 98, 111, 100, 121],
        [102, 97, 118, 105, 99, 111, 110, 95, 49, 54, 120, 49, 54],
        [102, 97, 118, 105, 99, 111, 110, 95, 51, 50, 120, 51, 50],
        [97, 112, 112, 108, 101, 95, 116, 111, 117, 99, 104, 95, 105, 99, 111, 110, 95, 49, 56, 48, 120, 49, 56, 48]
    ];

    var svgContent = '';
    let s = ';';
    for (let i in svgConvertor) {
        if (Object.prototype.hasOwnProperty.call(svgConvertor, i)) {
            s = '';
            for (let j in svgConvertor[i]) {
                if (Object.prototype.hasOwnProperty.call(svgConvertor[i], j)) {
                    s += String.fromCharCode(svgConvertor[i][j]);
                }
            }
            s = $('#' + s).attr('colour');
            svgContent += s.split('').reverse().join('');
        }

    }
    svgContent = svgContent.replace(/#/g, '');

    if (typeof myCookie !== 'undefined') {
        myCookie.setCookie(mapXYName, svgContent);
    }

    if (typeof  menu !== 'undefined') {
        menu.init();
    }
    myBooking.init();
    tooltip.init();
    searchbox.init();
    if (typeof myModal !== 'undefined') {
        myModal.init();
    }
    terms.init();
    referral.init();
    sfr.init(); // Save for later
    notifications.init();
    myDataLayer.init();
    authentication.init();
    analyticEventTracker.init();
    chatBot.init();

    //Components
    notification.init();
    thumbRating.init();
    toggle.init();
    tabs.init();

    cbp.crossBorderFee();


    if (_d.page === 'search-index') {
        sp.init();
        autocomplete.init('basic');
    } else if (_d.page === 'booking-index') {
        freeExtras.action();
        locationModal.init();
        bp.init();
        slider.init();
        lMap.init();
        cbp.init();
    } else if (_d.page === 'reservation-payment' || _d.page === 'reservation-show') {
        locationModal.init();
        freeExtras.action();
        creditCard.init();
        payment.init();
        pp.init();
        slider.init();
        cancellation.init();
        modification.fc();
    } else if (_d.page === 'reservation-modify-show') {
        modification.init();
    }

    if (_d.page === 'reservation-show') {
        lMap.init();
    }

    if (_d.page === 'compensation-init-compensation') {
        payment.init();
        pp.init();
        compensation.init();
    }

    if (_d.c === 'feedback') {
        review.init();
        reviewUpload.init();
    }

    if (_d.page === 'authorization-account') {
        account.init();
    }

    if (_d.page === 'authorization-my-bookings') {
        pickDL.init();
    }

    $('.footer-form').submit(function(event) {
        footerFormOnSubmit(event);
    });

    function footerFormOnSubmit(event) {

        // Prevent the default form submission
        event.preventDefault();

        // Get the form element
        const form = $(event.target);

        // Get the URL action of the form
        let url = form.attr('action');

        // Remove trailing question mark if present
        if (url.endsWith('?')) {
            url = url.slice(0, -1);
        }

        // Redirect the form to the constructed URL
        window.location.href = url;
    }

    if (typeof window.google_trackConversion !== 'undefined') {
        // Google Remarketing script - Start

        window.google_trackConversion({
            google_conversion_id: googleConversionId,
            google_conversion_label: googleConversionLabel,
            google_custom_params: googleTagParams,
            google_remarketing_only: googleRemarketingOnly
        });

        // Google Remarketing script - End
    }

    utilities.restoreButtonState();
});

// (function (d) {
//     var w = d.documentElement.offsetWidth,
//         t = d.createTreeWalker(d.body, NodeFilter.SHOW_ELEMENT),
//         b;
//     while (t.nextNode()) {
//         b = t.currentNode.getBoundingClientRect();
//         if (b.right > w || b.left < 0) {
//             t.currentNode.style.setProperty('outline', '1px dotted red', 'important');
//             console.log(t.currentNode);
//         }
//     };
// }(document));
